import { render, staticRenderFns } from "./liverCancerScreening.vue?vue&type=template&id=746f018c&scoped=true"
import script from "./liverCancerScreening.vue?vue&type=script&lang=js"
export * from "./liverCancerScreening.vue?vue&type=script&lang=js"
import style0 from "./liverCancerScreening.vue?vue&type=style&index=0&id=746f018c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "746f018c",
  null
  
)

export default component.exports